import { SelectorListProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: SelectorListProps = {
  dataSource: () =>
    Promise.resolve({
      items: [],
      totalCount: 0,
    }),
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as SelectorListProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
